/* eslint-disable import/first */
import React from 'react';
import { ListItem, ListItemSecondaryAction, ListItemText, Radio } from '@material-ui/core';
import css from './index.module.scss';

function ProductConfigurableRadio({ id, name, onChange, checked }) {
  const keyValue = `${id}-${name}`;
  return (
    <ListItem
      button
      htmlFor={id}
      onClick={onChange}
      key={keyValue}
      component="label"
      className={css.listItem}
    >
      <ListItemText primary={name} className={css.condTitle} />
      <ListItemSecondaryAction className={css.radio}>
        <Radio onChange={onChange} color="primary" edge="end" checked={checked ? true : false} />
      </ListItemSecondaryAction>
    </ListItem>
  );
}

export default ProductConfigurableRadio;
